import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"

export interface MarriageTaxYear {
	Year: number
	HighEarnerEarningsInRange: Nullable<boolean>
	LowEarnerEarningsInRange: Nullable<boolean>
}

export const MarriageTaxYearSchema = objectSchema<MarriageTaxYear>({
	Year: Number,
	HighEarnerEarningsInRange: Nullable(Boolean),
	LowEarnerEarningsInRange: Nullable(Boolean),
})

export interface TaxYearBracket {
	Year: number
	BracketMinimum: number
	BracketMaximum: number
}

export const TaxYearBracketSchema = objectSchema<TaxYearBracket>({
	Year: Number,
	BracketMinimum: Number,
	BracketMaximum: Number,
})
